export default function useGlobalUrl() {
  let rootUrl;
  if (window.location.hostname === 'localhost' && window.location.port === '8080') {
    rootUrl = 'http://localhost:3128';
  } else {
    rootUrl = 'https://contacts.westerninterlock.com';
  }

  // const graphqlUrl = `https://contacts.westerninterlock.com/data/graphql`;
  const graphqlUrl = `${rootUrl}/data/graphql`;
  const leadFileUrl = `${rootUrl}/lead-files`;
  const contactFileUrl = `${rootUrl}/contact-files`;
  const quoteProductImportUrl = `${rootUrl}/quote-products`;
  const emailUrl = `${rootUrl}/send-email`;
  const duplicatesMergeUrl = `${rootUrl}/duplicates/merge`;

  return {
    graphqlUrl,
    leadFileUrl,
    contactFileUrl,
    quoteProductImportUrl,
    rootUrl,
    emailUrl,
    duplicatesMergeUrl,
  };
}
